<template>
  <div>
    <button
      v-if="isButton"
      type="button"
      :disabled="isLoading || disabled  || OrderSampleEnabled"
      class="col pop-up-add-to-cart-button btn btn-primary mt-1 mb-2"
      @click.prevent="addItemToCart()"
    >
      <span v-if="isLoading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
      <span class="png-icon png-icon-icons-glyph--ko-my-basket"></span>
        {{ buttonText }}
    </button>
    <a
      v-else
      href="#addtobasket"
      class="font-16"
      :class="OrderSampleEnabled ? 'text-muted pointer-none' : ''"
      @click.prevent="OrderSampleEnabled ? '' : addItemToCart()"
    >
      <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status"></span>
      {{ buttonText }}
    </a>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { BASKET_PROJECTITEMS } from "../../constants/checkout-constant";

export default {
  data() {
    return {
      isLoading: false
    };
  },
  created() {
    this.isOrderSampleEnabled();
  },
  props: {
    sellingStyleNumber: {
      required: true
    },
    colorNumber: {
      required: true
    },
    vehicleId: {
      required: false
    },
    quantity: {
      required: true
    },
    saveForLater: {
      required: true,
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: "Add to basket"
    },
    inventoryStyleNumber: {
      type: String
    },
    isButton: {
      default: false
    },
    listName: {
      type: String
    },
  },
  computed: {
    ...mapGetters({
      selectedColor: "productDetail/color",
      OrderSampleEnabled: "productDetail/getisOrderSampleEnabled"
    })
  },
  methods: {
    ...mapActions({
      isOrderSampleEnabled: "productDetail/isOrderSampleEnabled",
    }),
    async addItemToCart() {
        this.isLoading = true;
        this.updateloader(true);
        let data = {
          sellingStyleNumber: this.sellingStyleNumber,
          colorNumber: this.colorNumber,
          vehicleId: this.vehicleId,
          quantity: this.quantity,
          saveForLater: true,
          InventoryStyleNumber: this.inventoryStyleNumber,
          SellingStyleNumber: this.sellingStyleNumber,
          isProjectItem: this.listName === BASKET_PROJECTITEMS ? true : false
        };
        await this.addToCart(data).finally(async () => {
          if (this.saveForLater) {
            await this.fetchBasketItem(this.listName);
            this.updateloader(true);
            await this.fetchSaveForLaterItems();
            this.updateloader(false);
          } else {
            this.updateloader(false);
          }
          this.isLoading = false;
          this.$emit('item-added-to-cart');
        });
   },
   ...mapActions({
      addToCart: "newBasketPage/addToCart",
      updateloader: "newBasketPage/updateLoader",
      fetchBasketItem: "newBasketPage/fetchBasketItem",
      fetchSaveForLaterItems: "newBasketPage/fetchSaveForLaterItems"
   })
  }
};
</script>